/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type BystanderAedCountTypeEnum =
  (typeof BystanderAedCountTypeEnum)[keyof typeof BystanderAedCountTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BystanderAedCountTypeEnum = {
  ONCE: 'ONCE',
  TWICE: 'TWICE',
  THREE: 'THREE',
  FOUR: 'FOUR',
  FIVE: 'FIVE',
  SIX: 'SIX',
  SEVEN: 'SEVEN',
  EIGHT: 'EIGHT',
  NINE: 'NINE',
  OVER_TEN: 'OVER_TEN',
} as const;
